import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
    Typography, Grid, IconButton, Button
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { v4 as uuidv4 } from 'uuid';

import { ErrorHandling, DialogeBox } from 'components'
import { genfunction } from 'helpers'
import OrderProduct from './components/OrderProduct'

import { actionDeleteOrderProduct, actionUpdateOrderProducts } from 'actions/actionShopCart'

const { CartDiscardMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    canceButtonlIcon: {
        '& svg': {
            fontSize: 20
        },
        padding: 0,
        paddingLeft: 10
    }
}));

const OrderItemsReview = props => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [errorMsg, seterrorMsg] = useState("");
    const [productPopUp, setProductPopUp] = useState({
        isOpen: false,
        Product: null,
        Department: null
    });

    const [productDeletePopUp, setProductDeletePopUp] = useState({
        isOpen: false,
        Product: null
    });

    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const orderLocation = useSelector(state => state.reducerOrderLocations.orderLocation);
    const carddiscard = useSelector(state => state.reducerCardDiscardTime);

    useEffect(() => {
        if ((orderProducts && orderProducts.length == 0)) {
            let tabLocationID = orderLocation.TabLocations[0].TabLocationID;
            props.history.push('/ordermenu/' + tabLocationID);
        }
    }, [orderProducts])

    const getAllTotal = () => {

        let amount = {
            subtotal: 0,
            tax: 0,
            total: 0
        }

        let foodAmount = genfunction.getOrderProductsTotalPrice(orderProducts);
        amount.subtotal += foodAmount.subtotal;
        amount.tax += foodAmount.tax;
        amount.total += foodAmount.total;

        return amount;
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const getProductOptions = (product) => {
        if (product.Options) {

            let productWithOptions = product.Options.filter(x => x.Products && x.Products.length > 0 && x.Products.find(y => y.IsSelected == true) != undefined);
            if (productWithOptions && productWithOptions.length > 0) {
                return (
                    productWithOptions.map(option => {
                        return (
                            option.Products.map(opproduct => {
                                return (
                                    opproduct.IsSelected ?
                                        <Typography variant='subtitle2'>
                                            {genfunction.replaceEscapeCharacters(opproduct.ProductName)}
                                        </Typography> : ""
                                )
                            }))
                    })
                );
            }
        }

        return "";
    }

    const onClickMakeChangesHandler = () => {
        let tabLocationID = orderLocation.TabLocations[0].TabLocationID;
        props.history.push('/ordermenu/' + tabLocationID);
    }

    const onClickFinishHandler = () => {
        props.history.push('/checkout');
    }


    const onClickProductHandler = (department, product) => {
        setProductPopUp({
            isOpen: true,
            Product: product,
            Department: department
        });
    }

    const onClickCancelProductHanlder = () => {
        errorcancelhandle();
        setProductPopUp({
            isOpen: false,
            Product: null,
            Department: null
        });
    }

    const hasSameOptions = (ProductA, ProductB) => {
        if (ProductA.Options && ProductB.Options) {
            return ProductA.Options.every(PAOption => {
                let PBOption = ProductB.Options.find(x => x.OptionName === PAOption.OptionName);
                if (PAOption.Products && PBOption.Products) {
                    let PAProduct = PAOption.Products.filter(x => x.IsSelected);
                    let PBProduct = PBOption.Products.filter(x => x.IsSelected);
                    if (PAProduct.length == PBProduct.length) {
                        return PAProduct.every(AProduct => {
                            if (PBProduct.find(x => x.ProductID === AProduct.ProductID) == undefined) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        });
                    }
                }
            });
        }
        else {
            return true;
        }
    }

    const onClickAddToCartProductHanlder = (Product) => {
        if (Product.Quantity == 0) {
            seterrorMsg("Please select quantity")
        }
        else if (genfunction.IsRequiredOptionsSelectedForOrderItem(Product) == false) {
            seterrorMsg("Please select required option first");
        }
        else {
            errorcancelhandle();
            let objSelectedProducts = [...orderProducts];

            let objProduct = objSelectedProducts.find(p => p.ProductID === Product.ProductID && p.ProductNotes === Product.ProductNotes && hasSameOptions(p, Product));
            if (objProduct) {
                if (objProduct.UniqueID == Product.UniqueID) {
                    objProduct.Quantity = Product.Quantity;
                }
                else {
                    objProduct.Quantity += Product.Quantity;
                    objSelectedProducts = objSelectedProducts.filter(x => x.UniqueID != Product.UniqueID);
                }
            }
            else {
                objProduct = Object.assign({}, Product);
                objProduct.UniqueID = uuidv4();
                objSelectedProducts.push(objProduct);
                objSelectedProducts = objSelectedProducts.filter(x => x.UniqueID != Product.UniqueID);
            }

            actionUpdateOrderProducts(dispatch, objSelectedProducts);

            setProductPopUp({
                isOpen: false,
                Product: null,
                Department: null
            });
        }
    }

    function millisecondsToTime(milli) {
        var seconds = Math.floor((milli / 1000) % 60);
        var minutes = Math.floor((milli / (60 * 1000)) % 60);
        return minutes + ":" + genfunction.PaddingString(seconds, "0", 2);
    }

    return (
        <Grid id="vt_page_order_items_review" container className={classes.root} justifyContent="center">
            <Grid container item spacing={2} xs={12} sm={10} md={8} lg={6}>
                <ErrorHandling color={"error"} msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Grid item xs={12} align="center">
                    <Typography variant="h1" color="textPrimary" >Review your Order</Typography>
                    <Typography variant="subtitle1" color="textPrimary" >{orderLocation.OrderLocation + " , " + orderLocation.TabLocations[0].TabLocationName}</Typography>

                    <Typography variant="h5" component="h5" style={{ marginTop: props.MarginTop }}>
                        {CartDiscardMsg} {" "} {millisecondsToTime(carddiscard.DiscardTime * 1000)}
                    </Typography>

                </Grid>
                {/* Food Order */}
                <Grid container item xs={12} spacing={2}>
                    {orderProducts.map(product => {
                        return (
                            <Grid key={product.ProductName + "_Food_ShopCart"} container item xs={12}>
                                <Grid item xs={1}>
                                    <IconButton
                                        className={classes.canceButtonlIcon}
                                        onClick={() => { onClickProductHandler(null, product) }}
                                    >
                                        <EditIcon color={"primary"} />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={6} align="left">
                                    <Typography variant='h6'>
                                        {genfunction.replaceEscapeCharacters(product.ProductName)}
                                    </Typography>
                                    {getProductOptions(product)}

                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant='h6'>
                                        x {product.Quantity}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} align="right">
                                    <Typography variant='h6'>
                                        {genfunction.ccyFormat(genfunction.getOrderProductsTotalPrice([product]).subtotal)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <IconButton
                                        className={classes.canceButtonlIcon}
                                        onClick={() => setProductDeletePopUp({ isOpen: true, Product: product })}
                                    >
                                        <DeleteIcon color={"error"} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>

                <Grid container xs={12} item spacing={2}>

                    <Grid item xs={7}>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant='h6'>
                            Subtotal
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="right">
                        <Typography variant='h6'>
                            {genfunction.ccyFormat(getAllTotal().subtotal)}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                    </Grid>

                    <Grid item xs={7}>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant='h6'>
                            Tax
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="right">
                        <Typography variant='h6'>
                            {genfunction.ccyFormat(getAllTotal().tax)}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                    </Grid>

                    <Grid item xs={7}>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography variant='h6'>
                            Total
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="right">
                        <Typography variant='h5'>
                            {genfunction.ccyFormat(getAllTotal().total)}
                        </Typography>
                    </Grid>
                    <Grid item xs={1}>
                    </Grid>
                </Grid>

                <Grid container item xs={12}>
                    <Grid item xs={6} align="center">
                        <Button className={classes.button} variant="outlined" color="primary"
                            onClick={onClickMakeChangesHandler}
                        >Add More Item</Button>
                    </Grid>
                    <Grid item xs={6} align="center">
                        <Button className={classes.button} variant="contained" color="primary"
                            disabled={orderProducts && orderProducts.length > 0 ? false : true}
                            onClick={onClickFinishHandler}
                        >Finish & Pay</Button>
                    </Grid>
                </Grid>

                <DialogeBox open={productDeletePopUp.isOpen} title="Confirmation"
                    message="You are about to remove the item from cart. are you sure?"
                    button1text="Yes"
                    button1clickhandler={() => { actionDeleteOrderProduct(dispatch, productDeletePopUp.Product); setProductDeletePopUp({ isOpen: false, Product: null }) }}
                    button2text="No"
                    button2clickhandler={() => setProductDeletePopUp({ isOpen: false, Product: null })}
                ></DialogeBox>

                {productPopUp && productPopUp.Product ?
                    <OrderProduct open={productPopUp.isOpen} Product={productPopUp.Product}
                        onConfirm={onClickAddToCartProductHanlder}
                        onCancel={onClickCancelProductHanlder}
                    >
                    </OrderProduct>
                    : ""}
            </Grid>
        </Grid >
    );
};

export default OrderItemsReview;